<template>
  <div>
    <el-popover ref="popover" trigger="click" v-model="isVisible">
      <div style="width: 220px;">
        <el-radio-group v-model="radioAvatar" @change="onAvatarChange">
          <el-radio :label="item" v-for="(item, index) in avatars" :key="index"
            ><el-avatar :src="item"></el-avatar
          ></el-radio>
        </el-radio-group>
      </div>
      <el-image class="form-avatar" :src="avatar" slot="reference"></el-image>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    avatar: {
      type: String,
      default: "",
    },
  },
  computed: {
    radioAvatar:{
      get() {
        return this.avatar
      },
      set(newValue) {
       this.$emit('avatarChange', newValue)
      }
    }
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods:{
    onAvatarChange(v){
      this.$emit('avatarChange', v)
    }
  }
};
</script>

<style lang="scss" scoped>
.form-avatar {
  position: relative;
  width: 40px;
  height: 40px;
}
::v-deep{
  input[aria-hidden=true]{
    display: none !important;
}
}
</style>